import { Component } from 'react'
import VideoModal from 'components/modal/video'

import styles from './partnerlinksblock.css'

type PartnerLinkProps = {
  image: number
  description: string
  url: string
  openModal: (videoUrl: string, e: Record<string, unknown>) => void
}

export const PartnerLink = ({ image, description, url, openModal }: PartnerLinkProps): JSX.Element => (
  <a className={styles.partnerLink} onClick={e => openModal(url, e)} role="button" tabIndex={0}>
    <img className={styles.image} src={`/is/${image}/fill-1000x0/`} alt="" />
    <div className={styles.partnerLinkText}>{description}</div>
  </a>
)

type PartnerLinksBlockProps = {
  value: {
    background_image: number
    title_image: number
    description_image: number
    description_url: string
    links: Array<PartnerLinkProps>
  }
}

type PartnerLinksBlockState = {
  modalIsOpen: boolean
  videoUrl: string
}

class PartnerLinksBlock extends Component<PartnerLinksBlockProps, PartnerLinksBlockState> {
  state = {
    modalIsOpen: false,
    videoUrl: '',
  }

  openModal = (videoUrl: string, e: React.MouseEvent) => {
    e.preventDefault()
    this.setState({ videoUrl, modalIsOpen: true })
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false })
  }

  render() {
    const {
      value: { background_image, title_image, description_image, links },
    } = this.props
    const { modalIsOpen, videoUrl } = this.state

    return (
      <div
        className={styles.background}
        style={{
          backgroundImage: `url("/is/${background_image}/fill-1600x594/")`,
        }}
      >
        <div className={styles.wrapper}>
          <div className={styles.imageWrapper}>
            <img className={styles.titleImage} src={`/is/${title_image}/fill-1000x0/`} alt="" />
          </div>
          <div className={styles.imageWrapper}>
            <img className={styles.descImage} src={`/is/${description_image}/fill-1000x0/`} alt="" />
          </div>
          <div className={styles.partnerLinks}>
            {links.map((link, index) => (
              <PartnerLink
                image={link.image}
                description={link.description}
                url={link.url}
                key={String(index)}
                openModal={this.openModal}
              />
            ))}
          </div>
        </div>
        <VideoModal videoUrl={videoUrl} isOpen={modalIsOpen} closeModal={this.closeModal} />
      </div>
    )
  }
}

export default PartnerLinksBlock
